import React from 'react'
import PropTypes from 'prop-types'

import slice from 'lodash/slice'

const isLandscape = window.matchMedia('(min-width: 1081px')
const PENDING_ORDERS_SLOTS = isLandscape.matches ? 7 : 6

const OrdersPendingList = ({ ordersPending }) => {
  const isManyOrders = ordersPending.length > PENDING_ORDERS_SLOTS
  const orders =
    ordersPending.length > PENDING_ORDERS_SLOTS
      ? slice(ordersPending, 0, PENDING_ORDERS_SLOTS - 1)
      : ordersPending
  const moreOrdersNumber = `+${ordersPending.length - orders.length} more`

  return (
    <section className="orders-pending">
      <header>
        <h3 className="orders-pending__header">Preparing</h3>
      </header>
      <ul className="orders-pending__list">
        {orders.map(order => (
          <li className="orders-pending__item" key={order}>
            {order}
          </li>
        ))}
        {isManyOrders && <li className="orders-pending__item -more">{moreOrdersNumber}</li>}
      </ul>
    </section>
  )
}

OrdersPendingList.propTypes = {
  ordersPending: PropTypes.array,
}

export default OrdersPendingList
